module.exports = __webpack_public_path__ + "img/Consolidated_Bank.1d933e6c.png";